export default __webpack_public_path__ + "static/media/cancelled.cbffc0fb.svg";